import { createApp } from 'vue'
import { MotionPlugin } from '@vueuse/motion'
import App from './App.vue'

// Icons
import 'boxicons/css/boxicons.min.css'

// Toastification
import Toast, { POSITION } from 'vue-toastification'
import 'vue-toastification/dist/index.css'

const toastOptions = {
  position: POSITION.BOTTOM_RIGHT,
  timeout: 3000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  hideProgressBar: false,
  icon: true,
}

const app = createApp(App)

app.use(MotionPlugin)
app.use(Toast, toastOptions)

app.mount('#app')
